import React from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

const EmptyCard = ({message}) => {
  let txt = message ? message : "Empty.  No text has been entered.";
  return (
      <Card key="empty" className="md-block-centered" style={{width: "100%"}} >
          <CardContent>
              <div>{txt}</div>
          </CardContent>
      </Card>
  );
};

EmptyCard.propTypes = {
    message: PropTypes.string
};
export {
  EmptyCard
};